import { render, staticRenderFns } from "./NewStockTakingComponent.vue?vue&type=template&id=14cf982d&scoped=true&"
import script from "./NewStockTakingComponent.vue?vue&type=script&lang=js&"
export * from "./NewStockTakingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cf982d",
  null
  
)

export default component.exports